// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".l-header--account-service[data-v-2ebb96ed]{align-items:center;background:#e0e0e0;justify-content:space-between;padding:0 150px}.l-header--account-service__title[data-v-2ebb96ed]{align-items:center;color:#000;display:flex;font-size:13px;height:100%}", ""]);
// Exports
module.exports = exports;
